import { OFFLINE_MAX_QUANTITY } from '../types';

/**
 * Barcode scan adds 1, or increments a line already in the cart.
 * Adding the same product replaces the line, so the request must send the new total.
 * Returns null when the line is already at the server maximum.
 */
export function nextScanQuantity(current: number | undefined): number | null {
  const base = current ?? 0;
  if (base >= OFFLINE_MAX_QUANTITY) return null;
  return base + 1;
}
